export default {
  container: {
    textAlign: 'center'
  },
  logoContainer: {
    width: 200,
    display: 'block',
    margin: 'auto'
  },
  header: {
    color: '#fff',
    display: 'none'
  },
  tag: {
    color: '#fff'
  }
};



// WEBPACK FOOTER //
// ./src/views/guest/coming-soon/ComingSoon.styles.js